import React, { useState } from 'react';

import * as S from './AssetLogotype.styles';

export interface AssetLogotypeProps {
  name: string;
  logoUrl?: string;
}

export const AssetLogotype = ({ name, logoUrl }: AssetLogotypeProps) => {
  const [hasError, setHasError] = useState(false);
  const firstLetter = name.charAt(0);
  const showLogo = !!logoUrl && !hasError;

  return (
    <S.Background hasLogo={showLogo} data-testid="asset-logotype">
      {showLogo ? (
        <S.Img src={logoUrl} alt={name} onError={() => setHasError(true)} />
      ) : (
        <S.Fallback data-testid="logo-fallback">{firstLetter}</S.Fallback>
      )}
    </S.Background>
  );
};
